import { normalizeDecimalSeparator, isNumericFieldType } from './numberInput';
import { Field } from '../types';
import { datetimeLocalToISO, timeInputToBackend, intervalInputToSeconds, normalizeIntervalDisplay } from './timestampUtils';

export const processFormData = (
    data: Record<string, any>,
    fields: Field[]
): Record<string, any> => {
    const processedData = { ...data };

    fields.forEach(field => {
        if (isNumericFieldType(field.type) && processedData[field.code]) {
            processedData[field.code] = normalizeDecimalSeparator(processedData[field.code]);
        }

        // Convert timestamp from datetime-local to ISO with timezone
        if (field.type === 'timestamp' && processedData[field.code]) {
            processedData[field.code] = datetimeLocalToISO(processedData[field.code]);
        }

        // Convert time from HH:mm to HH:mm:ss format
        if (field.type === 'time' && processedData[field.code]) {
            processedData[field.code] = timeInputToBackend(processedData[field.code]);
        }

        // Convert duration (HH:MM) to total seconds; empty -> null.
        // Normalize first so unblurred input ("13" -> "13:00") is correct.
        if (field.type === 'interval') {
            processedData[field.code] = intervalInputToSeconds(normalizeIntervalDisplay(processedData[field.code]));
        }

        if (Array.isArray(processedData[field.code])) {
            // Keep subform data as-is
            processedData[field.code] = processedData[field.code];
        }
    });

    return processedData;
};

export const getChangedData = (
    formData: Record<string, any>,
    initialFormData: Record<string, any>
): Record<string, any> => {
    const changedData: Record<string, any> = {};
    Object.keys(formData).forEach(key => {
        if (formData[key] !== initialFormData[key]) {
            changedData[key] = formData[key];
        }
    });
    return changedData;
};
